import { render } from "./HeadMenu.vue?vue&type=template&id=64fba246&scoped=true&ts=true"
import script from "./HeadMenu.vue?vue&type=script&lang=ts"
export * from "./HeadMenu.vue?vue&type=script&lang=ts"

import "./HeadMenu.vue?vue&type=style&index=0&id=64fba246&scoped=true&lang=scss"

import exportComponent from "/home/apps/bugaplus/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fba246"]])

export default __exports__